import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const OffertKategori = lazy(() => import("@/pages/info/OffertKategori"));

export const Route = createFileRoute("/solceller/")({
  head: () => seoHead("/solceller", { description: "Sänk elkostnaden med egen solel. Fyll i dina förutsättningar och få kostnadsfria offerter från upp till fyra installatörer." }),
  component: () => <OffertKategori slug="solceller" />,
});
